import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";
import {
  AddBusinessAddressPayloadType,
  AddCustomerSupplierPayloadType,
  EditBusinessAddressPayloadType,
  EditCustomerSupplierPayloadType,
  AddLedgerPayloadType,
  CheckUniqueLedgerPayloadType,
  GetAllLedgersListPayloadType,
  UpdateLedgerPayloadType,
  CheckUniqueLegalCustomerSupplierNamePayloadType,
  GetAllUnitMeasurementListPayloadType,
  AddUnitMeasurementListPayloadType,
  UpdateUnitsMeasermentPayloadType,
  AddStockItemPayloadType,
  UpdateStockGroupPayloadType,
  AddStockGroupPayloadType,
  GetAllStockItemListPayloadType,
  UpdateStockItemListPayloadType,
  CheckUniqueSkuNumberPayloadType,
  GetSingleCustomerSupplierListPayloadType,
  GetDepartmentListPayloadType,
  CreateDepartmentPayloadType,
  UpdateDepartmentPayloadType,
  UniqueDepartmentNamePayloadType,
  GetSingleStockItemListPayloadType,
  StockItemQuantityRatePayloadType,
  StockMultipleItemQuantityRatePayloadType,
  ChangeStatusCustomerSupplierPayloadType,
  AddPdfMappingTemplatePayloadType,
  GetPdfMappingTemplatePayloadType,
  StockUploadFilePayloadType,
  AddTurnOverHSNCheckPayloadType,
  UpdateTurnOverHSNCheckPayloadType,
  GetHSNCheckPayloadType,
  AddHSNCheckWarningPayloadType,
  CheckUniqueBatchNumberPayloadType,
  GetBatchListPayloadType,
  AddBatchPayloadType,
  UpdateBatchPayloadType,
  GetSingleBatchListPayloadType,
  ChangeStatusBatchListPayloadType,
  AddAutoUniqueNumberPayloadType,
  GetAutoUniqueNumberPayloadType,
  GetStockMappedBatchListPayloadType,
  GetCustomerSupplierGroupingListPayloadType,
  DownloadLedgerListPayloadType,
} from "../commonTypes/clientSettingsTypes";
import { getCSRFToken } from "../utils/commonFunctions";

/* Customer/Supplier Module */
export async function addCustomerSupplierApi(
  data: AddCustomerSupplierPayloadType
): Promise<AxiosResponse> {
  const { shippingAddressesData } = data;
  let finalData = {
    client_code: data?.client_code,
    type: data?.type,
    legal_name: data?.legalName.trim(),
    trade_name: data?.tradeName?.trim(),
    address1: data?.addressOne,
    address2: data?.addressTwo,
    city: data?.city,
    sent_overdue_email: data?.sentOverdueEmail,
    state: data?.state,
    country: data?.country,
    pincode: data?.pin?.trim(),
    mobile: data?.mobile?.trim(),
    telephone: data?.telephone?.trim(),
    email: data?.email?.trim(),
    website: data?.website,
    gst_number: data?.gst?.trim(),
    pan_number: data?.pan?.trim(),
    tin_number: data?.tin,
    msme_registration_no: data?.msmeRegistrationNo?.trim(),
    ledger_number: data?.ledger_number,
    registration_type: data?.registrationType?.trim(),
    registration_date: data?.registrationDate?.trim(),
    constitution_of_business: data?.constitutionOfBusiness?.trim(),
    company_status: data?.companyStatus?.trim(),
    shipping_addresses: shippingAddressesData,
    payment_details: data?.payment_details,
    signature: data?.signature,
    pan_details: data?.pan_details,
    default_income_ledger_id:data?.defaultIncomeLedgerId,
    default_expense_ledger_id:data?.defaultExpenseLedgerId,
    parent_id: data?.parentId,
    to_show: data?.toShow,
    make_sub_ledger: data?.makeSubLedger,
  };

  const finalRes = await postData(
    `invoice-generation/add/customer/supplier`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": data?.token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );

  return finalRes;
}

export async function editCustomerSupplierApi(
  data: EditCustomerSupplierPayloadType
): Promise<AxiosResponse> {
  const { shippingAddressesData } = data;
  let finalData = {
    client_code: data?.client_code,
    type: data?.type,
    legal_name: data?.legalName?.trim(),
    trade_name: data?.tradeName?.trim(),
    address1: data?.addressOne,
    address2: data?.addressTwo,
    city: data?.city,
    sent_overdue_email: data?.sentOverdueEmail,
    state: data?.state,
    country: data?.country,
    pincode: data?.pin?.trim(),
    mobile: data?.mobile?.trim(),
    telephone: data?.telephone?.trim(),
    email: data?.email?.trim(),
    website: data?.website,
    gst_number: data?.gst?.trim(),
    pan_number: data?.pan?.trim(),
    tin_number: data?.tin,
    msme_registration_no: data?.msmeRegistrationNo?.trim(),
    ledger_id: data?.ledger_id,
    ledger_number: data?.ledger_number,
    registration_type: data?.registrationType?.trim(),
    registration_date: data?.registrationDate?.trim(),
    constitution_of_business: data?.constitutionOfBusiness?.trim(),
    company_status: data?.companyStatus?.trim(),
    shipping_addresses: shippingAddressesData,
    payment_details: data?.payment_details,
    signature: data?.signature,
    pan_details: data?.pan_details,
    default_income_ledger_id:data?.defaultIncomeLedgerId,
    default_expense_ledger_id:data?.defaultExpenseLedgerId,
    parent_id: data?.parentId,
    to_show: data?.toShow,
    make_sub_ledger: data?.makeSubLedger,
  };

  return await postData(
    `invoice-generation/update/customer/supplier`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": data?.token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function changeCustomerSupplierStatusApi(
  data: ChangeStatusCustomerSupplierPayloadType
): Promise<AxiosResponse> {
  const { token, ledger_id, is_disabled, client_code } = data;
  const finalData = {
    is_disabled,
    ledger_id,
    client_code,
  };
  return await postData(`invoice-generation/disable/ledger`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllCustomerSupplierApi(
  data: any
): Promise<AxiosResponse> {
  const { token, client_code, search_term, offset, limit, type, data_req } =
    data;

  let finalParams = {
    client_code,
    limit,
    offset,
    type,
    to_show:1,
    data_req,
    ...(search_term?.length > 0 && { search_term: search_term }),
  };

  return await getData(`invoice-generation/customer/supplier/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleCustomerSupplierApi(
  data: GetSingleCustomerSupplierListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, customerSupplierId } = data;
  const finalParams = {
    client_code: client_code,
    ledger_id: customerSupplierId,
  };

  return await getData(`invoice-generation/customer/supplier`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// BULK UPLOAD CUSTOMER SUPPLIER

export async function customerSupplierBulkUploadApi(data: any): 
Promise<AxiosResponse> {
  const { token, client_code, fileData} = data;

  const formData = new FormData();
  formData.append("file", fileData);
  formData.append("client_code", client_code);

  return postData(`/invoice-generation/customer/supplier/bulkupload`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

/* Business Address Module */
export async function addBusinessAddressApi(
  data: AddBusinessAddressPayloadType
): Promise<AxiosResponse> {
  let finalData = {
    client_code: data?.client_code,
    ledger_number: data?.ledgerNumber,
    legal_name: data?.legalName?.trim(),
    trade_name: data?.tradeName?.trim(),
    address1: data?.addressOne,
    address2: data?.addressTwo,
    city: data?.city,
    state: data?.state,
    country: data?.country,
    pincode: data?.pin?.trim(),
    mobile: data?.mobile?.trim(),
    telephone: data?.telephone?.trim(),
    email: data?.email?.trim(),
    gst_number: data?.gst?.trim(),
    pan_number: data?.pan?.trim(),
    msme_registration_no: data?.msmeRegistrationNo?.trim(),
    tan_number: data?.tan?.trim(),
    cin_number: data?.cin?.trim(),
    tin_number: data?.tin,
    website: data?.website,
    udyog_aadhar_number: data?.udyogAadhar?.trim(),
    employer_professional_tax: data?.professionalTaxEmployer?.trim(),
    person_professional_tax: data?.professionalTaxEmpoyee?.trim(),
    service_tax_number: data?.serviceTaxNumber?.trim(),
    iec_code_number: data?.iecCode?.trim(),
    eighty_iac_registration_number: data?.iacRegistration?.trim(),
    startup_india_registration_number: data?.startUpIndiaNumber?.trim(),
    epfo_number: data?.epfoNumber?.trim(),
    esic_number: data?.esicNumber?.trim(),
    notes: data?.notes?.trim(),
    invoice_heading: data?.invoiceHeading?.trim(),
    logo_details: data?.logo_details,
    is_default_address: data?.isDefaultAddress,
    registration_type: data?.registrationType?.trim(),
    registration_date: data?.registrationDate?.trim(),
    constitution_of_business: data?.constitutionOfBusiness?.trim(),
    company_status: data?.companyStatus?.trim(),
    payment_details: data?.payment_details,
    signature: data?.signature,
    gst_username: data?.gstUsername,
    pan_details: data?.pan_details,
    tan_details: data?.tan_details,
    authorized_signatory_pan_number: data?.authorizedSignatoryPanNumber?.trim(),
    authorized_signatory_name: data?.authorizedSignatoryName?.trim(),
    authorized_signatory_email: data?.authorizedSignatoryEmail?.trim(),
    authorized_signatory_phone_number: data?.authorizedSignatoryPhoneNumber,
    authorized_signatory_pan_details: data?.authorized_signatory_pan_details,
  };

  return postData(`invoice-generation/add/address`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": data?.token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getSingleBusinessAddressApi(
  data: any
): Promise<AxiosResponse> {
  const { token, client_code, ledger_id } = data;
  const finalParams = {
    client_code: client_code,
    ledger_id,
  };

  return await getData(`invoice-generation/address`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function editBusinessAddressApi(
  data: EditBusinessAddressPayloadType
): Promise<AxiosResponse> {
  let finalData = {
    client_code: data?.client_code,
    ledger_id: data?.ledger_id,
    ...(data?.ledgerNumber && {ledger_number: data?.ledgerNumber}),
    legal_name: data?.legalName?.trim(),
    trade_name: data?.tradeName?.trim(),
    address1: data?.addressOne,
    address2: data?.addressTwo,
    city: data?.city,
    state: data?.state,
    country: data?.country,
    pincode: data?.pin?.trim(),
    mobile: data?.mobile?.trim(),
    telephone: data?.telephone?.trim(),
    email: data?.email?.trim(),
    website: data?.website,
    gst_number: data?.gst?.trim(),
    pan_number: data?.pan?.trim(),
    msme_registration_no: data?.msmeRegistrationNo?.trim(),
    tan_number: data?.tan?.trim(),
    cin_number: data?.cin?.trim(),
    tin_number: data?.tin,
    udyog_aadhar_number: data?.udyogAadhar?.trim(),
    employer_professional_tax: data?.professionalTaxEmployer?.trim(),
    person_professional_tax: data?.professionalTaxEmpoyee?.trim(),
    service_tax_number: data?.serviceTaxNumber?.trim(),
    iec_code_number: data?.iecCode?.trim(),
    eighty_iac_registration_number: data?.iacRegistration?.trim(),
    startup_india_registration_number: data?.startUpIndiaNumber?.trim(),
    epfo_number: data?.epfoNumber?.trim(),
    esic_number: data?.esicNumber?.trim(),
    notes: data?.notes?.trim(),
    invoice_heading: data?.invoiceHeading?.trim(),
    logo_details: data?.logo_details,
    is_default_address: data?.isDefaultAddress,
    registration_type: data?.registrationType?.trim(),
    registration_date: data?.registrationDate?.trim(),
    constitution_of_business: data?.constitutionOfBusiness?.trim(),
    company_status: data?.companyStatus?.trim(),
    payment_details: data?.payment_details,
    signature: data?.signature,
    gst_username: data?.gstUsername,
    pan_details: data?.pan_details,
    tan_details: data?.tan_details,
    authorized_signatory_pan_number: data?.authorizedSignatoryPanNumber?.trim(),
    authorized_signatory_name: data?.authorizedSignatoryName?.trim(),
    authorized_signatory_email: data?.authorizedSignatoryEmail?.trim(),
    authorized_signatory_phone_number: data?.authorizedSignatoryPhoneNumber,
    authorized_signatory_pan_details: data?.authorized_signatory_pan_details,
  };
  return postData(`invoice-generation/update/address`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": data?.token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllBusinessAddressesApi(
  data: any
): Promise<AxiosResponse> {
  const { client_code, token, search_term } = data;

  let finalParams = {
    client_code,
    ...(search_term?.length > 0 && { search_term: search_term }),
  };

  return getData(`invoice-generation/address/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

/* Accounts Manager Module */
export async function getAllLedgersListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    token,
    search_term,
    offset = 0,
    limit = 10000000,
    data_req,
  } = data;

  let finalParams = {
    client_code,
    offset,
    limit,
    data_req,
    ...(search_term && search_term?.length > 0 && { search_term: search_term }),
  };

  return getData(`invoice-generation/ledger/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllExpensesLedgersListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const { client_code, token } = data;

  return getData(`invoice-generation/ledger/list/based_on_type`, {
    params: {
      client_code,
      ledger_types: "nature_of_expense",
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllIncomeLedgersListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, data_req } = data;

  return getData(`invoice-generation/ledger/list/based_on_type`, {
    params: {
      client_code,
      ledger_types: "nature_of_income",
      data_req,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addLegerApi(
  data: AddLedgerPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    ledger_type,
    ledger_name,
    ledger_number,
    token,
    parent_id,
    to_show,
    cog_type,
  } = data;
  let finalData = {
    client_code,
    ledger_type,
    ledger_name,
    ledger_number,
    ...(parent_id && { parent_id }),
    to_show,
    cog_type,
  };

  return postData(`invoice-generation/add/ledger`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateLedgerApi(
  data: UpdateLedgerPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    ledger_id,
    ledger_name,
    ledger_number,
    ledger_type,
    parent_id,
    to_show,
    cog_type,
    is_tree,
  } = data;

  let finalData = {
    client_code,
    ledger_id,
    ledger_name,
    ledger_number,
    ledger_type,
    ...(parent_id && { parent_id }),
    to_show,
    cog_type,
    is_tree,
  };

  return postData(`invoice-generation/update/ledger`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkUniqueLedgerApi(
  data: CheckUniqueLedgerPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, ledger_number } = data;

  return getData(`invoice-generation/ledger/number/unique`, {
    params: {
      client_code,
      ledger_number,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleTypeLedgerListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, ledger_type } = data;

  return getData(`invoice-generation/ledger/list`, {
    params: {
      client_code,
      ledger_type,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllTypesLedgerListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, data_req } = data;

  return getData(`invoice-generation/ledger/list/based_on_type`, {
    params: {
      client_code,
      ledger_types:
        "nature_of_expense,nature_of_income,payment,assets,liabilities,supplier_customer,equity",
      data_req,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllTypesWithTaxListApi(
  data: GetAllLedgersListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, data_req } = data;

  return await getData(`invoice-generation/ledger/list/based_on_type`, {
    params: {
      client_code,
      ledger_types:
        "nature_of_expense,nature_of_income,payment,assets,liabilities,supplier_customer,tax,equity",
      data_req,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function checkUniqueLegalCustomerSupplierNameApi(
  data: CheckUniqueLegalCustomerSupplierNamePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, legal_name } = data;

  return await getData(`invoice-generation/legal/name/unique`, {
    params: {
      client_code,
      legal_name: legal_name?.trim(),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getAllUnitMeasurementListApi(
  data: GetAllUnitMeasurementListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code } = data;

  return await getData(`invoice-generation/stock/unit/list`, {
    params: {
      client_code,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addAllUnitMeasurementListApi(
  data: AddUnitMeasurementListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    stockUnitName,
    stockUnitSymbol,
    numOfDecimalPlaces,
    uniqueQuantityCode,
  } = data;

  const finalData = {
    client_code,
    stock_unit_name: stockUnitName,
    stock_unit_symbol: stockUnitSymbol,
    no_of_decimal_places: numOfDecimalPlaces,
    unique_quantity_code: uniqueQuantityCode,
  };

  return await postData(`invoice-generation/add/stock/unit`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateAllUnitMeasurementListApi(
  data: UpdateUnitsMeasermentPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    stockUnitId,
    stockUnitName,
    stockUnitSymbol,
    numOfDecimalPlaces,
    uniqueQuantityCode,
  } = data;

  const finalData = {
    client_code,
    stock_unit_name: stockUnitName,
    stock_unit_id: stockUnitId,
    stock_unit_symbol: stockUnitSymbol,
    no_of_decimal_places: numOfDecimalPlaces,
    unique_quantity_code: uniqueQuantityCode,
  };

  return await postData(`invoice-generation/update/stock/unit`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkUniqueSkuNumberApi(
  data: CheckUniqueSkuNumberPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, sku } = data;

  return getData(`invoice-generation/stock/item/check/sku`, {
    params: {
      client_code,
      SKU: sku,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addStockItemListApi(
  data: AddStockItemPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    sku,
    stockGroupId,
    stockItemName,
    stockUnitId,
    gstApplicable,
    hsnSacNo,
    hsnSacDetails,
    taxability,
    gst,
    cess,
    vatApplicable,
    vatTaxType,
    vatTaxRate,
    byProduct,
    coProduct,
    scrap,
    rate,
    uploads,
    maximum,
    minimum,
  } = data;
  const finalData = {
    client_code,
    stock_group_id: stockGroupId,
    SKU: sku,
    stock_item_name: stockItemName,
    stock_unit_id: stockUnitId,
    GST_applicable: gstApplicable,
    HSN_SAC_no: hsnSacNo,
    HSN_SAC_details: hsnSacDetails,
    taxability,
    GST: gst,
    Cess: cess,
    VAT_applicable: vatApplicable,
    VAT_tax_type: vatTaxType,
    VAT_tax_rate: vatTaxRate,
    by_product: byProduct,
    co_product: coProduct,
    scrap,
    rate,
    uploads,
    min_quantity: minimum,
    max_quantity: maximum,
  };
  return await postData(`invoice-generation/add/stock/item`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function updateStockItemListApi(
  data: UpdateStockItemListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    sku,
    stockItemId,
    stockGroupId,
    stockItemName,
    stockUnitId,
    gstApplicable,
    hsnSacNo,
    hsnSacDetails,
    taxability,
    gst,
    cess,
    vatApplicable,
    vatTaxType,
    vatTaxRate,
    byProduct,
    coProduct,
    scrap,
    rate,
    uploads,
    maximum,
    minimum,
  } = data;

  const finalData = {
    client_code,
    stock_group_id: stockGroupId,
    SKU: sku,
    stock_item_id: stockItemId,
    stock_item_name: stockItemName,
    stock_unit_id: stockUnitId,
    GST_applicable: gstApplicable,
    HSN_SAC_no: hsnSacNo,
    HSN_SAC_details: hsnSacDetails,
    taxability,
    GST: gst,
    Cess: cess,
    VAT_applicable: vatApplicable,
    VAT_tax_type: vatTaxType,
    VAT_tax_rate: vatTaxRate,
    by_product: byProduct,
    co_product: coProduct,
    scrap,
    rate,
    uploads,
    min_quantity: minimum,
    max_quantity: maximum,
  };
  return await postData(`invoice-generation/update/stock/item`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// /?client_code=22&stock_item_id=173

export async function getSingleStockItemApi(
  data: GetSingleStockItemListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, stock_item_id } = data;

  return await getData(`invoice-generation/stock/item/details`, {
    params: {
      client_code,
      stock_item_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllStockItemListApi(
  data: GetAllStockItemListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, limit, offset, search_term } = data;
  return await getData(`invoice-generation/stock/item/list`, {
    params: {
      client_code,
      limit,
      offset,
      ...(search_term &&
        search_term.length > 0 && { search_term: search_term }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllStocksGroupListApi(
  data: any
): Promise<AxiosResponse> {
  const { token, client_code, search_term, limit, offset } = data;

  let finalParams = {
    client_code,
    limit,
    offset,
    ...(search_term?.length > 0 && { search_term: search_term }),
  };
  return await getData(`invoice-generation/stock/group/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addStockGroupApi(
  data: AddStockGroupPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    token,
    stock_group_name,
    is_quantities_enabled,
    parent_group_id,
  } = data;
  let finalData = {
    client_code,
    stock_group_name,
    is_quantities_enabled,
    parent_group_id,
  };

  return postData(`invoice-generation/add/stock/group`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateStockGroupApi(
  data: UpdateStockGroupPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    is_quantities_enabled,
    parent_group_id,
    stock_group_name,
    stock_group_id,
  } = data;

  let finalData = {
    client_code,
    is_quantities_enabled,
    parent_group_id,
    stock_group_name,
    stock_group_id,
  };

  return postData(`invoice-generation/update/stock/group`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function parentStockGroupApi(data: any): Promise<AxiosResponse> {
  const { token, client_code } = data;

  let finalParams = {
    client_code,
  };
  return await getData(`invoice-generation/stock/group/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//  department
export async function getDepartmentListApi(
  data: GetDepartmentListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, limit, offset, searchValue, status } = data;
  return await getData(`/invoice-generation/department/list`, {
    params: {
      client_code,
      limit,
      offset,
      status,
      // search_term:searchValue
      ...(searchValue &&
        searchValue.length > 0 && { search_term: searchValue }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// unique check
export async function checkUniqueDepartmentNameApi(
  data: UniqueDepartmentNamePayloadType
): Promise<AxiosResponse> {
  const { token, operation, client_code, departmentName, id } = data;

  const finalParams = {
    operation,
    department_name: departmentName,
    client_code: client_code,
    id: id,
  };
  return await getData(`/invoice-generation/unique/check`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createDepartmentApi(
  data: CreateDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, departmentName, status, client_code } = data;
  const finalData = {
    department_name: departmentName,
    status: status,
    client_code: client_code,
  };

  return await postData(`/invoice-generation/add/department`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateDepartmentApi(
  data: UpdateDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, id, departmentName, status, client_code } = data;
  const finalData = {
    id: id,
    department_name: departmentName,
    status: status,
    client_code: client_code,
  };
  return await postData(`/invoice-generation/update/department`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getMultipleStockItemQuantityApi(
  data: StockMultipleItemQuantityRatePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, stock_item_ids, date } = data;

  const finalParams = {
    client_code,
    stock_item_ids,
    date,
  };

  return await getData(
    `/invoice-generation/bill-of-material/stock-items/details`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function createMappedPdfTemplateApi(
  data: AddPdfMappingTemplatePayloadType
): Promise<AxiosResponse> {
  const { token, pdfTemplateId, clientCode, defaultPdfTemplateId, invoiceType } = data;
  const finalData = {
    pdf_template_id: pdfTemplateId,
    client_code: clientCode,
    default_pdf_template_id: defaultPdfTemplateId,
    invoice_type: invoiceType,
  };

  return await postData(
    `/invoice-generation/pdf-template/client-mapping/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getMappedPdfTemplateApi(
  data: GetPdfMappingTemplatePayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, invoiceType } = data;

  const finalParams = {
    client_code: clientCode,
    invoice_type: invoiceType,
  };

  return await getData(`/invoice-generation/pdf-template/client-mapping/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function multipleUploadFilesApi(filesData: any): Promise<any> {
  const { token, fileData, containerType, clientCode } = filesData;

  const formData = new FormData();

  formData.append("container_type", containerType);
  if (clientCode) {
    formData.append("client_code", clientCode);
  }
  formData.append("files", fileData);

  return await postData("finac/blob/upload", formData, {
    headers: {
      "user-token": token,
      "Content-Type": "multipart/form-data",
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// BULK UPLOAD STOCK ITEMS

export async function StockItemBulkUploadApi(data: any): Promise<AxiosResponse> {
  const { client_code, fileData, token } = data;

  const formData = new FormData();
  formData.append("file", fileData);
  formData.append("client_code", client_code);

  return postData(`invoice-generation/stock/item/bulkupload`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function addTurnOverHSNCheckApi(
  data: AddTurnOverHSNCheckPayloadType
): Promise<AxiosResponse> {
  const { token, clientTurnover, clientCode, isHSNCheck } = data;
  const finalData = {
    client_turnover: clientTurnover,
    client_code: clientCode,
    is_hsn_sac_code_check_active: isHSNCheck,
  };

  return await postData(
    `invoice-generation/hsn-check/turnover/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateTurnOverHSNCheckApi(
  data: UpdateTurnOverHSNCheckPayloadType
): Promise<AxiosResponse> {
  const { token, clientTurnover, clientCode, isHSNCheck } = data;
  const finalData = {
    client_turnover: clientTurnover,
    client_code: clientCode,
    is_hsn_sac_code_check_active: isHSNCheck,
  };

  return await postData(
    `invoice-generation/hsn-check/turnover/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}



export async function getHsnCheckApi(
  data: GetHSNCheckPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode } = data;

  const finalParams = {
    client_code: clientCode,
  };

  return await getData(`invoice-generation/hsn-check/turnover/get`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}



export async function addHsnCheckWarningApi(
  data: AddHSNCheckWarningPayloadType
): Promise<AxiosResponse> {
  const { token, invoiceId, clientCode, stockItemId ,invoiceType,warningSkippedAt,skuNumber,invoiceNumber} = data;
  const finalData = {
    invoice_id: invoiceId,
    client_code: clientCode,
    stock_item_id: stockItemId,
    invoice_type:invoiceType,
    warning_skipped_at:warningSkippedAt,
    sku_number:skuNumber,
    invoice_number:invoiceNumber
  };

  return await postData(
    `invoice-generation/hsn-check/warning/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}


export async function addBatchManagementApi(
  data: AddBatchPayloadType
): Promise<AxiosResponse> {
  const { token, batchNumber, clientCode, expiryDate, manufacturingDate,status , stockItem} = data;
  const finalData = {
    client_code: clientCode,
    batch_number:batchNumber?.trim(),
    expiry_date:expiryDate,
    manufacturing_date:manufacturingDate,
    is_enable:status,
    stock_item_id:stockItem
  };

  return await postData(
    `invoice-generation/batch/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateBatchManagementApi(
  data: UpdateBatchPayloadType
): Promise<AxiosResponse> {
  const { token, batchNumber, clientCode, expiryDate, manufacturingDate,status , stockItem,batchId} = data;
  const finalData = {
    client_code: clientCode,
    batch_number:batchNumber,
    expiry_date:expiryDate,
    manufacturing_date:manufacturingDate,
    is_enable:status,
    stock_item_id:stockItem,
    batch_id:batchId
  };
  return await postData(
    `invoice-generation/batch/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getBatchManagementApi(
  data: GetBatchListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, limit, offset, search_term, is_enable } = data;

  const finalParams = {
    client_code: clientCode,
    offset,
    limit,
    ...(is_enable && {is_enable}),
    ...(search_term && search_term.length > 0 && {search_term: search_term}),
  };

  return await getData(`invoice-generation/batch/get`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function getSingleBatchManagementApi(
  data: GetSingleBatchListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, batchId } = data;
  const finalParams = {
    client_code: clientCode,
    batch_id: batchId,
  };

  return await getData(`invoice-generation/batch/getbyid`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function changeBatchStatusApi(
  data: ChangeStatusBatchListPayloadType
): Promise<AxiosResponse> {
  const { token, batch_id, is_enable } = data;
  const finalData = {
    is_enable,
    batch_id,
  };
  return await postData(`invoice-generation/batch/change/status`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkUniqueBatchNumberApi(
  data: CheckUniqueBatchNumberPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, batch_number } = data;

  return getData(`invoice-generation/batch/unique`, {
    params: {
      client_code,
      batch_number,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Add Auto Unique Number Generation API
 
export async function addAutoUniqueNumberGenerationApi(
  data: AddAutoUniqueNumberPayloadType
) : Promise<AxiosResponse> {
  const {
    clientCode,
    token,
    general_settings_type,
    isAutoUniqueNumberCheck,
  } = data;
  let finalData = {
    client_code: clientCode,
    general_settings_type,
    is_enable: isAutoUniqueNumberCheck,
  };
 
  return await postData(`invoice-generation/add-update/general-settings`, finalData,{
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  }
  );
}
 
export async function getAutoUniqueNumberGenerationCheckApi(
  data: GetAutoUniqueNumberPayloadType
): Promise<AxiosResponse> {
  const {
    clientCode,
    general_settings_type,
    token,
  } = data;
  let finalParams = {
    client_code: clientCode,
    general_settings_type,
  };
 
  return await getData(`invoice-generation/general-settings/get`, {
    params: {
      ...finalParams
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function getStockMappedBatchListApi(
  data: GetStockMappedBatchListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode,stockId ,isEnable} = data;

  const finalParams = {
    client_code: clientCode,
    stock_id:stockId,
    is_enable:isEnable
  };

  return await getData(`invoice-generation/stock/batch/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// customer supplier grouping

export async function getCustomerSupplierGroupingListApi(
  data: GetCustomerSupplierGroupingListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, type, search_term, offset, limit,} = data;

  const finalParams = {
    client_code: clientCode,
    type: type && type ,
    limit,
    offset,
    ...(search_term?.length && search_term?.length > 0 && { search_term: search_term }),
  };

  return await getData(`invoice-generation/customer/supplier/grouping/list`,{
    params: {
      ...finalParams
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// download ledger list 

export async function downloadLedgerListApi(
  data: DownloadLedgerListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    startDate,
    endDate,
    search_term
  } = data;
  let finalParams = {
    client_code,
    start_date: startDate,
    end_date: endDate,
    ...(search_term?.length && search_term?.length > 0 && { search_term: search_term })
  };
  return await getData(`invoice-generation/ledger/list/download`, {
    params: {
      ...finalParams,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// download customer supplier grouping list

export async function downloadCustomerSupplierGroupingListApi(
  data: DownloadLedgerListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    startDate,
    endDate,
    search_term,
    type
  } = data;
  let finalParams = {
    client_code,
    start_date: startDate,
    end_date: endDate,
    ...(search_term?.length && search_term?.length > 0 && { search_term: search_term }),
    type: type && type,
  };
  return await getData(`invoice-generation/customer/supplier/grouping/list/download`, {
    params: {
      ...finalParams,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// download stock item list

export async function downloadStockItemListApi(
  data: DownloadLedgerListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    startDate,
    endDate,
    search_term
  } = data;
  let finalParams = {
    client_code,
    start_date: startDate,
    end_date: endDate,
    ...(search_term?.length && search_term?.length > 0 && { search_term: search_term })
  };
  return await getData(`invoice-generation/stock/item/list/download`, {
    params: {
      ...finalParams,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}